export default __webpack_public_path__ + "static/media/home-icon.8bbbccc4.webp";